import { Status } from '@webapp/ui';
import { IUserList } from '../interfaces/users.interface';

export function buildStatus(user: IUserList) {
	if (user.status === 'ACTIVE') {
		return { badgeStatus: Status.Success, badgeText: 'Activo' };
	}
	if (user.status === 'BLOCKED') {
		return { badgeStatus: Status.Warning, badgeText: 'Bloqueado' };
	}
	return { badgeStatus: Status.Info, badgeText: 'Inactivo' };
}
